/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import QRCode from 'qrcode';
import { I18n } from 'react-redux-i18n';

class ApkDownloadQrCode extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dataUrl: '',
      error: false,
    };
  }

  componentDidMount() {
    this.renderQrCode();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.value !== this.props.value
      || prevProps.size !== this.props.size
    ) {
      this.renderQrCode();
    }
  }

  renderQrCode = async () => {
    const { value, size = 240 } = this.props;

    if (!value) {
      this.setState({ dataUrl: '', error: false });
      return;
    }

    try {
      const dataUrl = await QRCode.toDataURL(String(value), {
        width: size,
        margin: 1,
        errorCorrectionLevel: 'M',
      });

      this.setState({ dataUrl, error: false });
    } catch (e) {
      this.setState({ dataUrl: '', error: true });
    }
  };

  render() {
    const { dataUrl, error } = this.state;
    const size = this.props.size || 240;

    return (
      <div>
        <div
          style={{
            width: size,
            height: size,
            border: '1px solid #d5dbe0',
            padding: 8,
            background: '#fff',
            boxSizing: 'content-box',
          }}
        >
          {!!dataUrl && (
            <img
              src={dataUrl}
              alt="QR Code"
              width={size}
              height={size}
              style={{ display: 'block' }}
            />
          )}
        </div>
        {error && (
          <small className="text-danger">
            {I18n.t('BEE4787' /* Não foi possível gerar o QR Code. */)}
          </small>
        )}
      </div>
    );
  }
}

export default ApkDownloadQrCode;
